import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const AdjustmentsIcon =  ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    {...restProps}>
    <path
      fill={fill}
className={`dark:${
        isActive
          ? "fill-primary"
          : "fill-caption group-hover:dark:fill-primary"
      }`}
      fillRule="evenodd"
      d="M6 3a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v1.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-9.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm-6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-6 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default AdjustmentsIcon;
